module.exports = __webpack_public_path__ + "media/headers/reserva_hora-e0a8cbbf.png";